/* eslint-disable */
import React, { useEffect, useState, useContext, useRef} from 'react';
import pad from 'pad';
import { 
  Row,
  Col,
  Pagination,
} from 'react-bootstrap';
import Card from '../../components/card.component';
import tableGuia from './entrega.table';
import DataTable from 'react-data-table-component';
import guiasFunction from './entrega.functions';
import { ConfigContext } from '../../context/config.context';
import utils from '../../utils/utils.functions';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import Modal from '../../components/modal/modal.component';
import EntregaModal from '../../components/entrega.component';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import ClienteComponentModal from '../../components/clientesmodal.component';
import masterFunction from '../master/master.functions';
import {
  faSearch,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../assets/css/fix-table.scss';
import EstadosGuias from '../../components/estadomaster.component';
import EstadoPaquete from '../../components/estadospaquetes.component';
import { useDebounceValue } from '../../components/debounceSearch.component';

const Entrega = () => {

  const selectTipo = useRef();
  const selectTipoEnv = useRef();
  const selectMaster = useRef();

  const history = useHistory();
  const { config } = useContext(ConfigContext);
  const { setPreloader } = useContext(ConfigContextUtils);
  const [listado, setListado] = useState([]);
  const [fullListado, setFullListado] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [seleccion, setSeleccion] = useState(null);
  const [pending, setPending] = useState(true);
  const [clienteModal, setClienteModal] = useState(false);
  const [cliente, setCliente] = useState(null);
  const [filtros, setFiltros] = useState(null);
  const [modalEstado, setModalEstado] = useState(false);
  const [tipoSalida, setTipoSalida] = useState(null);
  const [listadoMaster, setListadoMaster] = useState([]);
  const [tracking, setTracking] = useState(null);
  const [pagination, setPagination] = useState({
    pagination: 1,
    isLastPage: false,
    lastPage: 0,
  });
  const [findText, setFindText] = useState('');

  const deboncedValue = useDebounceValue(findText, 1500);

  const GUIAS_MAESTRAS_ACTIVAS = 1;

  const listaMaster = () => {
    masterFunction.listadoFiltro(GUIAS_MAESTRAS_ACTIVAS)
      .then((response) => {
        setListadoMaster(response);
      })
  }

  useEffect(() => {
    listaMaster();
  },[]);

  const listadoGuias = (data) => {
    guiasFunction.listadoV2(data).then((response) => {
      setListado(response.data.guias_totales);
      setFullListado(response.data.guias_totales);
      setPagination({
        pagination: response.data.pagination,
        isLastPage: response.data.is_last_page,
        lastPage: response.data.last_page,
      });
      setPending(false);
      setPreloader(false);
    })
  }

  useEffect(() => {
     if (deboncedValue.trim() !== '') {
        setFiltros({
          findtext: deboncedValue,
        });
        selectTipo.current.selectedIndex = 0;
        selectMaster.current.selectedIndex = 0;
        selectTipoEnv.current.selectedIndex = 0;
        setCliente(null);
     } else {
        setFindText('');
        setFiltros({});
     }
  }, [deboncedValue])

  const goDetalleGuia = (row) => {
    history.replace(`/detalle/${row.uuid}`)
  }
  
  const entregaModal = (row) => {
    setModalShow(!modalShow);
    setSeleccion(row);
  }

  const estadosModal = (row) => {
    setModalEstado(!modalEstado);
    setSeleccion(row);
  }

  const refrescardata = (fila) => {
    setModalShow(false);
    const updateValues = [...listado];
    const indexFila = updateValues.findIndex(item => item.uuid === fila.uuid);
    updateValues[indexFila] = fila;
    setListado(updateValues);
  }

  const changeTipos = (sl) => {
    let value = sl.target.value;
    setFiltros({
      ...filtros,
      tipo_salida: value === 'todos_tipos' ? value : parseInt(value),
    });
    setFindText('');
  }

  const filtrarGuia = (sl) => {
    let value = sl.target.value;
    setFiltros({
      ...filtros,
      guia: value === 'null' ? 'all' : parseInt(value),
    });
    setFindText('');
  }

  const filtrarguias = (sl) => {
    let value = sl.target.value;
    if (value === 'todas' && !filtros.cliente && (!filtros.tipo_salida || filtros.tipo_salida === 'todos_tipos')) {
      setPreloader(true);
      setFiltros(null);
    } else {

      let keys = Object.keys(filtros);
      let cleanPayload = {};
      let filterFormat = {...filtros};
      keys.map((item) => {
        if (item === 'guia_pendiente' || item === 'anulado' || item === 'entregados' || item === 'todos') {
          delete filterFormat[item];
        }
      })

      const payload = {
        ...( value === 'reserva' && { guia_pendiente: 1 }),
        ...( value === 'anuladas' && { anulado: 1 }),
        ...( value === 'entregados' && { entregados: 1 }),
        ...( value === 'todas' && { todos: 1 }),
        ...( cliente && { cliente: cliente.id }),
      }

      setFiltros({
        ...payload,
        ...filtros,
      });
      setFindText('');
    }
  }

  const getguiasfiltros = (payload) => {
    setPreloader(true);
    guiasFunction.filtro(payload).then((response) => {
      setListado(response.data.guias_totales);
      setFullListado(response.data.guias_totales);
      setPagination({
        pagination: response.data.pagination,
        isLastPage: response.data.is_last_page,
        lastPage: response.data.last_page,
      });
      setPreloader(false);
      setPending(false);
    })
  }

  const filtroCliente = () => {
    if (cliente) {
      setFiltros({
        ...filtros,
        cliente: null,
      });
      setCliente(null);
    } else {
      setClienteModal(!clienteModal);
    }
  }
  
  const clientefiltroselector = (cliente) => {
    setFiltros({
      ...filtros,
      cliente: cliente.id,
    });
    setCliente(cliente);
    setClienteModal(!clienteModal);
  }

  useEffect(() => {
    if (filtros) {
      const payload = {
        ...filtros,
        pagination: 1,
      }
      getguiasfiltros(payload);
    } else {
      listadoGuias(pagination);
    }
  },[filtros])


  const trackingPackage = (item) => {
    setTracking(item);
  }

  const nextPage = () => {
    if (!pagination.isLastPage) {
      listadoGuias({
        pagination: pagination.pagination + 1,
        ...filtros,
      });
    }
  }

  const prevPage = () => {
    if (pagination.pagination > 1) {
        listadoGuias({
          pagination: pagination.pagination - 1,
          ...filtros,
        });
    }
  }

  const lastPage = () => {
    listadoGuias({
      pagination: pagination.lastPage,
      ...filtros,
    });
  }

  const firstPage = () => {
    listadoGuias({
      pagination: 1,
      ...filtros,
    });
  }

  return (
    <>
    <Row>
      <Col lg={12}>
        <Card>
          <Row>
            <Col lg={4}>
              <div className="grupo-input">
                <small>Numero de guia:</small>
                <input type="text"
                  className={`form-control input-border`}
                  name="guia_busqueda"
                  placeholder="Ingrese numero de guia"
                  onChange={(ev => setFindText(ev.target.value))}
                  value={findText}
                  />
              </div>
            </Col>
            <Col lg={4}>
              <div className="grupo-input">
                <small>Filtro:</small>
                <select ref={selectTipo} onChange={filtrarguias} className={`form-control input-border`}>
                  <option value="todas">Todas las guias</option>
                  <option value="reserva">Guias reservadas</option>
                  <option value="anuladas">Guias anuladas</option>
                  <option value="entregados">Entregados</option>
                </select>
              </div>
            </Col>
            <Col lg={4}>
              <div className="grupo-input">
                <small>Tipos de Envíos:</small>
                <select ref={selectTipoEnv} onChange={changeTipos} className={`form-control input-border`}>
                  <option value="todos_tipos">Todos</option>
                  { config.tipo_salidas.map(item => (
                    <option key={item.id} value={item.id}>{item.description}</option>
                  )) }
                </select>
              </div>
            </Col>
            <Col lg={4}>
              <div className="grupo-input">
                <small>Seleccione Guía Master</small>
                <select ref={selectMaster} onChange={filtrarGuia} className="form-control">
                  <option value="null">Todos</option>
                 {listadoMaster.map((e) => {
                    return <option key={e.id} value={e.id}>{pad(5,e.id,'0')} - {e.rel_tipos.description} - {e.description}</option>
                  })};
                </select>
              </div>
            </Col>
            <Col className="boton-end">
              <div className="grupo-input d-flex justify-content-start flex-column">
                <button type="button" className="btnx btnx-warn mt-1" onClick={filtroCliente}>
                   {cliente ? 
                     <>
                       <FontAwesomeIcon icon={faTimes} /> {cliente.name.toUpperCase()}
                     </>
                    :
                    <>
                      <FontAwesomeIcon icon={faSearch} /> Filtrar por cliente
                    </>
                   }
                </button>
                <ClienteComponentModal
                  onSelected={clientefiltroselector}
                  visibleOpen={clienteModal}
                  onClose={() => setClienteModal(false)}
                />
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    <Row className="mt-3">
      <Col>
        <Card>
        <DataTable
            title="Guias"
            customStyles={tableGuia.customStyles}
            columns={tableGuia.colummnsPaquete(config, goDetalleGuia,entregaModal,estadosModal, trackingPackage, utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones))}
            data={listado}
            dense={true}
            //pagination={true}
            progressPending={pending}
            //paginationPerPage={25}
            progressComponent={
              <h3>Cargando...</h3>
            }
            noDataComponent="No existen datos registrados para mostrar."
            style={{ 
              minHeight: 400,
            }}
          />
          <Row>
            <Col className="d-flex justify-content-end">
              <Pagination>
                <Pagination.First
                   onClick={firstPage}
                   disabled={pagination.pagination === 1 ? true : false}
                />
                <Pagination.Prev
                   onClick={prevPage}
                   disabled={pagination.pagination === 1 ? true : false}
                />
                <Pagination.Next 
                  onClick={nextPage}
                  disabled={pagination.isLastPage}
                />
                <Pagination.Last
                  onClick={lastPage}
                  disabled={pagination.isLastPage}
                />
              </Pagination>
           </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal show={modalShow}>
        <Card>
            <div>
              {seleccion !== null ?
              <EntregaModal 
                onClose={() => setModalShow(false)}
                onUpdate={refrescardata}
                data={seleccion}
                config={config}
                show={modalShow}
              />
              : null}
            </div>
        </Card>               
      </Modal>

      {seleccion &&
        <Modal show={modalEstado}>
          <Card>
              <div>
                <EstadosGuias 
                  onClose={() => setModalEstado(false)}
                  datos={{
                    id: seleccion.id,
                    allSelected: false,
                  }}
                  unit={true}
                  master={{
                    id: null
                  }}
                  guias={0}
                  show={modalEstado}
                />
              </div>
          </Card>               
        </Modal>
      }

       <EstadoPaquete guia={tracking} onClose={() => setTracking(null)} />
    </>
  )
}

export default Entrega;